import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'],
})
export class ButtonComponent implements OnInit {
  @Output('onClick') click = new EventEmitter();

  @Input() text: string;
  @Input() loading: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  onClick() {
    this.click.emit();
  }
}
